import {useCookiesConsent} from "@/features/auth/hooks/useCookiesConsent";
import {useGoogleAnalytics} from "@/features/system/hooks/useGoogleAnalytics";

export const SystemLayout = ({children}: {children: React.ReactNode}) => {
  useCookiesConsent();
  useGoogleAnalytics();

  return <div className="flex h-dvh flex-col">{children}</div>;
};
